module.exports = __webpack_public_path__ + "img/Lapp Kabel.72272ab3.png";